import { render, staticRenderFns } from "./FbSelectOption.vue?vue&type=template&id=71998ae4"
import script from "./FbSelectOption.vue?vue&type=script&lang=js"
export * from "./FbSelectOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports